import axios from "axios";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import $javelink_api from "../../api/services/javelink_api";
import {TOKEN} from "../../storage/user";
import {ABORTED_ERROR} from "../../utils/vars/staticVariables";
import {errorMessage} from "../../api/helpers/scripts";


export const getSubscriptionsAccountingData = createAsyncThunk(
        "subscriptionsAccounting/getSubscriptionsAccountingData",
        async (params, {signal, rejectWithValue}) => {

            const copiedParams = new URLSearchParams(params);

            if (copiedParams.has('email')) {
                const emailValue = copiedParams.get('email');
                copiedParams.delete('email');
                copiedParams.set('search', emailValue);
            }

            try {
                const {data} = await $javelink_api.get(
                    "/account-subscriptions/subscription-statistic/?" + copiedParams, {
                        signal,
                    });
                return data
            } catch (error) {
                let err = errorMessage(error);

                if (axios.isCancel(error)) {
                    return rejectWithValue();
                }

                throw new Error(err);
            }
        },
    )
;

export const getAllVipBotTeams = createAsyncThunk(
        "subscriptionsAccounting/getAllVipBotTeams",
        async () => {
            try {
                const {data} = await $javelink_api.get(
                    "/account-subscriptions/get-all-bot-teams/");

                return data
            } catch (error) {
                let err = errorMessage(error);

                throw new Error(err);
            }
        },
    )
;

export const subscriptionsAccountingSetNote = createAsyncThunk("subscriptionsAccounting/subscriptionsAccountingSetNote", async (noteData) => {
    try {
        // const response = await axios.post("https://stage-subscriptions.wwa-ios.com/subscriptions/subscription/subscription-statistic-info/set-note/",
        //     noteData,
        //     {
        //         headers: {
        //             Authorization: `Bearer ${TOKEN}`
        //         }
        //     });

        const response = await axios.post("https://api.wwa-ios.com/subscriptions/subscription/subscription-statistic-info/set-note/",
            noteData,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });

        const {data, status} = response;

        return {data, status};
    } catch (error) {
        const {data, status} = error.response;

        return {data, status};
    }
});


export const subscriptionsAccountingSetExtraMark = createAsyncThunk("subscriptionsAccounting/subscriptionsAccountingSetExtraMark", async (requestData) => {
    try {
        const response = await axios.post("https://api.wwa-ios.com/subscriptions/subscription/subscription-statistic-info/set-extra-mark/",
            requestData,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });

        const {data, status} = response;

        return {data, status};
    } catch (error) {
        const {data, status} = error.response;

        return {data, status};
    }
});

export const subscriptionsAccountingSetExtraMarkDetail = createAsyncThunk("subscriptionsAccounting/subscriptionsAccountingSetExtraMarkDetail", async (requestData) => {
    try {
        const response = await axios.post("https://api.wwa-ios.com/subscriptions/subscription/subscription-statistic-info/set-extra-mark-detail/",
            requestData,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });

        const {data, status} = response;

        return {data, status};
    } catch (error) {
        const {data, status} = error.response;

        return {data, status};
    }
});


const subscriptionsAccountingSlice = createSlice({
    name: "subscriptionsAccounting",
    initialState: {
        subscriptionsAccountingData: [],
        subscriptionsAccountingDataPending: false,
        subscriptionsAccountingRecordsCount: null,

        setExtraMarkPending: false,
        setExtraMarkDetailPending: false,
        allVipBotTeamsArray: [],
        setNotePending: false,
    },
    reducers: {
        updateSubscriptionAccountingData: (state, {payload}) => {
            const {subscription_service_id, key, value} = payload;

            state.subscriptionsAccountingData = state.subscriptionsAccountingData.map(obj =>
                obj.subscription_service_id === subscription_service_id
                    ? {...obj, [key]: value}
                    : obj
            );
        }
    },
    extraReducers: (builder) => {
        builder

            .addCase(getAllVipBotTeams.pending, (state) => {
                state.allVipBotTeamsArray = [];
            })
            .addCase(getAllVipBotTeams.fulfilled, (state, {payload}) => {
                state.allVipBotTeamsArray = payload;
            })
            .addCase(getAllVipBotTeams.rejected, (state) => {
                state.allVipBotTeamsArray = [];
            })


            .addCase(getSubscriptionsAccountingData.pending, (state) => {
                state.subscriptionsAccountingDataPending = true;
                state.subscriptionsAccountingData = [];
            })
            .addCase(getSubscriptionsAccountingData.fulfilled, (state, {payload}) => {
                const {
                    results,
                    count,
                } = payload;

                state.subscriptionsAccountingData = results;
                state.subscriptionsAccountingRecordsCount = count;

                state.subscriptionsAccountingDataPending = false;
            })
            .addCase(getSubscriptionsAccountingData.rejected, (state, {error}) => {
                const {message} = error;

                state.subscriptionsAccountingDataPending = message === ABORTED_ERROR;
                state.subscriptionsAccountingData = [];

                if (message !== ABORTED_ERROR) {
                    state.subscriptionsAccountingRecordsCount = 0;
                }
            })

            .addCase(subscriptionsAccountingSetNote.pending, (state) => {
                state.setNotePending = true
            })
            .addCase(subscriptionsAccountingSetNote.fulfilled, (state) => {
                state.setNotePending = false
            })
            .addCase(subscriptionsAccountingSetNote.rejected, (state) => {
                state.setNotePending = false
            })

            .addCase(subscriptionsAccountingSetExtraMark.pending, (state) => {
                state.setExtraMarkPending = true
            })
            .addCase(subscriptionsAccountingSetExtraMark.fulfilled, (state) => {
                state.setExtraMarkPending = false
            })
            .addCase(subscriptionsAccountingSetExtraMark.rejected, (state) => {
                state.setExtraMarkPending = false
            })

            .addCase(subscriptionsAccountingSetExtraMarkDetail.pending, (state) => {
                state.setExtraMarkDetailPending = true
            })
            .addCase(subscriptionsAccountingSetExtraMarkDetail.fulfilled, (state) => {
                state.setExtraMarkDetailPending = false
            })
            .addCase(subscriptionsAccountingSetExtraMarkDetail.rejected, (state) => {
                state.setExtraMarkDetailPending = false
            })
    },
});

export const {
    updateSubscriptionAccountingData
} = subscriptionsAccountingSlice.actions;

export default subscriptionsAccountingSlice.reducer;

export const subscriptionsAccountingSelector = (state) => state.subscriptionsAccounting;